// extracted by mini-css-extract-plugin
export var cookiebar = "Cookiebar-module--cookiebar--W2HEl";
export var hasAnswered = "Cookiebar-module--hasAnswered--1pPCb";
export var isHideAnimationEnded = "Cookiebar-module--isHideAnimationEnded--cb0uJ";
export var cookiebarInner = "Cookiebar-module--cookiebarInner--vm1aG";
export var button = "Cookiebar-module--button--WT+J+";
export var label = "Cookiebar-module--label--aTcQ1";
export var underline = "Cookiebar-module--underline--bolQY";
export var acceptButton = "Cookiebar-module--acceptButton--PE75D";
export var declineButton = "Cookiebar-module--declineButton--cy5zd";